import { z } from 'zod';

type T = (key: string) => string;

export const createContainerTypeSchema = (t: T) =>
  z.object({
    name: z.string().min(1, t('containerTypeNameRequired')),
    status: z.enum(['active', 'inactive'])
  });

export const containerTypeSchema = createContainerTypeSchema((key) => {
  const defaults: Record<string, string> = {
    containerTypeNameRequired: 'Name is required.'
  };
  return defaults[key] ?? key;
});

export type ContainerTypeFormValues = z.infer<typeof containerTypeSchema>;
